export interface CookieManagerResponse {
	succes: boolean;
	cookiestatus: Status;
}

export enum Status {
	ACCEPTED = 'accepted',
	DECLINED = 'declined',
	EMPTY = '',
}

export interface EmittedValuesInterface {
	'valk-analytics-cookie': boolean;
	'valk-functional-cookie': boolean;
	'valk-marketing-cookie': boolean;
}

export type CookieKey =
	| 'valk-functional-cookie'
	| 'valk-analytics-cookie'
	| 'valk-marketing-cookie';

export interface CookiePreferencesResponse {
	data: Record<CookieKey, boolean>;
}

export interface SetCookieResponse {
	data: {
		success: boolean;
	};
}
